export enum endpoints {
  ACCESS_TOKEN = '/access-token',
}
